<template>
  <div class="profile">
    <div class="page-404 bg-white rounded py-4 px-6">
      <div class="show-text">Please check that the URL you entered is correct, or click the button below to return to the homepage.</div>
     <div class="show-button">
       <el-button class="back-to-home btn-main ocr-button" @click="backToHome">
         Back to home
       </el-button>
     </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import {ROLE_ADMIN} from "@/constants/organization";

export default {
  data: function() {
    return {
    }
  },
  computed: {
    ...mapState({
      authUser: state => state.auth.authUser,
    })
  },
  methods: {
    backToHome() {
      if (this.authUser.role === ROLE_ADMIN && this.authUser.is_superuser) {
        this.$router.push('/admin/organizations')
        return true
      }
      this.$router.push('/')
    }
  },
  async created() {
  },
};
</script>
<style scoped>
.show-text {
  font-size: 20px;
  text-align: center;
  padding-bottom: 10px;
}
.show-button {
 text-align: center;
}
.page-404 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 80vh;
}
.back-to-home {
  width: 200px;
  height: 50px;
  font-size: 20px;
  margin: auto;
}
</style>
